import type { ICookie } from 'cookie-universal'

const SESSION_DEVICE_ID_COOKIE = 'session_device_id'

export const getSessionDeviceId = (cookies: ICookie): string | null => {
  // First try to get from cookie (for subsequent requests)
  const existingId = cookies.get(SESSION_DEVICE_ID_COOKIE)
  if (existingId) {
    return existingId
  }

  return null
}
